<template>
  <transition name="modal-fade">
    <div class="modal-backdrop pt-80">
      <div class="modal w-full h-full" role="dialog">
        <header class="modal-header">
          <slot name="header">
            <span class="text-left font-bold text-xl">
              Todos os Insights
            </span>
          </slot>

          <button type="button" class="btn-close" @click="close">
            x
          </button>
        </header>

        <section class="modal-body">
          <slot name="body">
            <button class="rounded bg-gray-300 hover:bg-gray-500 hover:cursor-pointer p-1.5 mr-2 float-right" @click="exportPDF">
              EXPORTAR PDF
            </button>

            <tabs ref="tabs">
              <tab v-if="suggestions.length > 0" title="Sugestões de Ações">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="suggestion in suggestions" :key="`${suggestion.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ suggestion.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ suggestion.before ? suggestion.before : suggestion.action }}
                        </p>

                        <div v-if="suggestion.accompanies && suggestion.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in suggestion.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="suggestion.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ suggestion.after }}
                        </p>
                      </span>

                      <hr v-if="suggestions.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(suggestions)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(suggestions)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="suggestionsAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in suggestionsAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="suggestionsAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="actions.length > 0" title="Ações">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="action in actions" :key="`${action.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ action.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ action.before ? action.before : action.action }}
                        </p>

                        <div v-if="action.accompanies && action.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in action.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="action.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ action.after }}
                        </p>
                      </span>

                      <hr v-if="actions.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(actions)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(actions)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="actionsAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in actionsAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="actionsAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="policies.length > 0" title="Políticas Públicas">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="policy in policies" :key="`${policy.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ policy.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ policy.before ? policy.before : policy.action }}
                        </p>

                        <div v-if="policy.accompanies && policy.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in policy.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="policy.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ policy.after }}
                        </p>
                      </span>

                      <hr v-if="policies.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(policies)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(policies)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="policiesAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in policiesAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="policiesAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="predictions.length > 0" title="Predições">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="prediction in predictions" :key="`${prediction.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ prediction.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ prediction.before ? prediction.before : prediction.action }}
                        </p>

                        <div v-if="prediction.accompanies && prediction.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in prediction.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="prediction.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ prediction.after }}
                        </p>
                      </span>

                      <hr v-if="predictions.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(predictions)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(predictions)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="predictionsAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in predictionsAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="predictionsAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="intelligences.length > 0" title="Inteligências de Mercado">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="intelligence in intelligences" :key="`${intelligence.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ intelligence.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ intelligence.before ? intelligence.before : intelligence.action }}
                        </p>

                        <div v-if="intelligence.accompanies && intelligence.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in intelligence.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="intelligence.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ intelligence.after }}
                        </p>
                      </span>

                      <hr v-if="intelligences.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(intelligences)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(intelligences)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="intelligencesAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in intelligencesAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="intelligencesAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="others.length > 0" title="Outros Insights">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="other in others" :key="`${other.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ other.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ other.before ? other.before : other.action }}
                        </p>

                        <div v-if="other.accompanies && other.accompanies.length > 0" class="p-3">
                          <div
                            v-for="accompany in other.accompanies"
                            :key="`${accompany.accompany} - ${Math.random() + accompany.index}`"
                            class="flex m-1 p-1 border-2 border-solid border-indigo"
                          >
                            <p class="text-justify whitespace-pre-line break-words pb-4 ml-0 mr-3">
                              {{ accompany.index }}. {{ accompany.accompany }}
                            </p>

                            <label class="form-label my-auto ml-auto mr-1 text-center">
                              <input
                                v-model="accompanieds[accompany._id]"
                                type="checkbox"
                                :disabled="accompany.selected"
                                @change="selectAccompany(accompany._id)"
                              />
                            </label>
                          </div>
                        </div>

                        <p v-if="other.after" class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ other.after }}
                        </p>
                      </span>

                      <hr v-if="others.length > 1" class="mb-4 mt-2" />
                    </div>

                    <div v-if="hasAccompanies(others)" class="mt-3">
                      <div class="flex">
                        <loading-button
                          type="button"
                          class="btn-indigo mr-3"
                          :loading="requesting"
                          :disabled="requesting || !selectedAccompanies"
                          @click="saveAccompanies(others)"
                        >
                          Salvar Ações selecionadas
                        </loading-button>

                        <span v-if="timer" class="timer-fade text-yellow-500 ml-0 my-auto mr-auto">
                          <strong>Aguarde...</strong>
                          Essa ação pode levar alguns minutos.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </tab>

              <tab v-if="othersAccompanies.length > 0" title="Acompanhamentos">
                <div class="overflow-y-auto">
                  <div class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="accompany in othersAccompanies" :key="`${accompany.answer} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold cursor-pointer" @click="invertDisplay(accompany._id)">
                          {{ accompany.accompany }}
                          <font-awesome-icon :id="`${accompany._id}-chevron-down`" icon="fa-chevron-down" size="lg" />
                          <font-awesome-icon :id="`${accompany._id}-chevron-up`" icon="fa-chevron-up" size="lg" class="hidden" />
                        </span>

                        <span :id="`${accompany._id}-accompany`" class="hidden">
                          <p class="text-justify mt-3 whitespace-pre-line break-words">
                            {{ accompany.steps }}
                          </p>

                          <span v-if="accompany.status !== 'IMPLEMENTED' && accompany.status !== 'CANCELLED'">
                            <span class="flex my-3">
                              <font-awesome-icon
                                icon="fa-file-lines"
                                size="3x"
                                class="ml-auto"
                                :class="{
                                  'text-gray-300': !accompany.status
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-signature"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-file-import"
                                size="3x"
                                :class="{
                                  'text-gray-300': !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING'
                                }"
                              />

                              <font-awesome-icon
                                icon="fa-minus"
                                size="3x"
                                class="mx-3"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED',
                                  'text-red-700': accompany.status === 'CANCELLED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status !== 'CANCELLED'"
                                icon="fa-file-circle-check"
                                size="3x"
                                class="mr-auto"
                                :class="{
                                  'text-gray-300': (
                                    !accompany.status ||
                                    accompany.status === 'ANALYZING' ||
                                    accompany.status === 'PLANNING' ||
                                    accompany.status === 'EXECUTING'
                                  ),
                                  'text-green-600': accompany.status === 'IMPLEMENTED'
                                }"
                              />

                              <font-awesome-icon
                                v-if="accompany.status === 'CANCELLED'"
                                icon="fa-file-circle-xmark"
                                size="3x"
                                class="mr-auto text-red-700"
                              />
                            </span>

                            <select
                              v-model="accompany.status"
                              class="form-control form-select w-1/4 mx-auto"
                              :disabled="requesting"
                              @change="setAccompanyStatus(accompany)"
                            >
                              <option :value="null" />
                              <option value="ANALYZING">Em Análise</option>
                              <option value="PLANNING">Em Planejamento</option>
                              <option value="EXECUTING">Em Execução</option>
                              <option value="IMPLEMENTED">Ação Implementada</option>
                              <option value="CANCELLED">Ação Cancelada</option>
                            </select>
                          </span>

                          <span v-if="accompany.status === 'IMPLEMENTED' && accompany.impact === null">
                            <span class="flex">
                              <span class="font-bold mt-3 mx-auto">
                                Essa ação causou impacto positivo ou negativo?
                              </span>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo ml-auto mr-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, true)">
                                Positivo
                              </button>

                              <button class="text-red-600 mr-auto ml-3" type="button" :disabled="requesting" @click="setAccompanyImpact(accompany, false)">
                                Negativo
                              </button>
                            </span>
                          </span>

                          <span v-if="!accompany.commentary && ((accompany.status === 'IMPLEMENTED' && accompany.impact !== null) || accompany.status === 'CANCELLED')">
                            <span class="flex my-3">
                              <div class="w-2/3 mx-auto">
                                <textarea-input :id="`${accompany._id}-text`" v-model="accompany.commentary" class="w-full" label="Deixe seu comentário" />
                              </div>
                            </span>

                            <span class="flex my-3">
                              <button class="btn-indigo m-auto" type="button" :disabled="requesting" @click="endAccompany(accompany)">
                                Finalizar
                              </button>
                            </span>
                          </span>

                          <span v-if="accompany.commentary" class="flex">
                            <span class="font-bold mt-3 mx-auto">
                              Muito obrigado por sua resposta!
                            </span>
                          </span>
                        </span>
                      </span>

                      <hr v-if="othersAccompanies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </div>
              </tab>
            </tabs>

            <vue-html2pdf
              ref="pdf"
              :show-layout="false"
              :float-layout="true"
              :enable-download="true"
              :preview-modal="false"
              :pdf-quality="2"
              :manual-pagination="true"
              pdf-format="a4"
              pdf-orientation="landscape"
              pdf-content-width="1100px"
            >
              <section slot="pdf-content">
                <center>
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />
                  <br />

                  <h1 class="text-center text-xl font-weight-bold">
                    Radar SET - DTI

                    <br />

                    {{ questionnaire }} ({{ state }} - {{ city }})
                  </h1>

                  <br />
                  <br />

                  <div v-if="suggestions.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="suggestion in suggestions" :key="`${suggestion.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ suggestion.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ suggestion.original ? suggestion.original : suggestion.action }}
                        </p>
                      </span>

                      <hr v-if="suggestions.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>

                  <br v-if="suggestions.length > 0" />
                  <br v-if="suggestions.length > 0" />

                  <div v-if="actions.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="action in actions" :key="`${action.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ action.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ action.original ? action.original : action.action }}
                        </p>
                      </span>

                      <hr v-if="actions.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>

                  <br v-if="actions.length > 0" />
                  <br v-if="actions.length > 0" />

                  <div v-if="policies.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="policy in policies" :key="`${policy.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ policy.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ policy.original ? policy.original : policy.action }}
                        </p>
                      </span>

                      <hr v-if="policies.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>

                  <br v-if="policies.length > 0" />
                  <br v-if="policies.length > 0" />

                  <div v-if="predictions.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="prediction in predictions" :key="`${prediction.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ prediction.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ prediction.original ? prediction.original : prediction.action }}
                        </p>
                      </span>

                      <hr v-if="predictions.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>

                  <br v-if="predictions.length > 0" />
                  <br v-if="predictions.length > 0" />

                  <div v-if="intelligences.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="intelligence in intelligences" :key="`${intelligence.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ intelligence.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ intelligence.original ? intelligence.original : intelligence.action }}
                        </p>
                      </span>

                      <hr v-if="intelligences.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>

                  <br v-if="intelligences.length > 0" />
                  <br v-if="intelligences.length > 0" />

                  <div v-if="others.length > 0" class="border rounded-lg p-5 m-2 mt-5 overflow-hidden shadow">
                    <div v-for="other in others" :key="`${other.title} - ${Math.random()}`">
                      <span>
                        <span class="text-left font-bold">
                          {{ other.title }}
                        </span>

                        <p class="text-justify mt-3 whitespace-pre-line break-words">
                          {{ other.original ? other.original : other.action }}
                        </p>
                      </span>

                      <hr v-if="others.length > 1" class="mb-4 mt-2" />
                    </div>
                  </div>
                </center>
              </section>
            </vue-html2pdf>
          </slot>
        </section>
      </div>
    </div>
  </transition>
</template>

<script>
import Tabs from '@/Shared/Tabs'
import Tab from '@/Shared/Tab'
import VueHtml2pdf from 'vue-html2pdf'
import LoadingButton from '@/Shared/LoadingButton'
import axios from 'axios'
import TextareaInput from '@/Shared/TextareaInput'

export default {
  components: {
    Tab,
    Tabs,
    VueHtml2pdf,
    LoadingButton,
    TextareaInput,
  },
  props: {
    insights:      Array,
    questionnaire: String,
    state:         String,
    city:          String,
  },
  data() {
    const $this = this

    return {
      timer: false,
      requesting: false,
      selectedAccompanies: false,
      get suggestions() {
        return $this.getByType('SUGGESTION')
      },
      get suggestionsAccompanies() {
        return $this.getAccompaniesByType('SUGGESTION')
      },
      get actions() {
        return $this.getByType('ACTION')
      },
      get actionsAccompanies() {
        return $this.getAccompaniesByType('ACTION')
      },
      get policies() {
        return $this.getByType('POLICY')
      },
      get policiesAccompanies() {
        return $this.getAccompaniesByType('POLICY')
      },
      get predictions() {
        return $this.getByType('PREDICTION')
      },
      get predictionsAccompanies() {
        return $this.getAccompaniesByType('PREDICTION')
      },
      get intelligences() {
        return $this.getByType('INTELLIGENCE')
      },
      get intelligencesAccompanies() {
        return $this.getAccompaniesByType('INTELLIGENCE')
      },
      get others() {
        return $this.getByType('OTHER')
      },
      get othersAccompanies() {
        return $this.getAccompaniesByType('OTHER')
      },
    }
  },
  methods: {
    saveAccompanies(selected) {
      if (this.requesting) {
        return
      }

      const accompanieds = []

      for (const id in this.accompanieds) {
        if (this.accompanieds[id]) {
          accompanieds.push(Number(id))
        }
      }

      this.requesting = true

      let timeout = setTimeout(() => this.timer = true, 1e4)

      axios.post(
        this.route('indicators.accompany'),
        {
          _token: this.$page.props.auth.user.csrf_token,
          accompanieds,
        },
      ).then((res) => {
        selected.forEach((action) => {
          if (action.accompanies && action.accompanies.length > 0) {
            action.accompanies.forEach((accompany) => {
              if (accompanieds.includes(accompany._id)) {
                accompany.selected = true

                accompany.steps = res.data[accompany._id]
              }
            })
          }
        })

        this.requesting = false
      }).catch(() => {
        this.requesting = false
      }).finally(() => {
        if (timeout) {
          clearTimeout(timeout)

          timeout = null
        }

        this.timer = false
      })
    },
    setAccompanyStatus(accompany) {
      if (this.requesting) {
        return
      }

      this.requesting = true

      axios.post(
        this.route('indicators.accompanying'),
        {
          _token: this.$page.props.auth.user.csrf_token,
          id: Number(accompany._id),
          status: accompany.status,
        },
      ).then(() => {
        this.requesting = false

        setTimeout(() => this.invertDisplay(accompany._id), 1e2)
      }).catch(() => {
        this.requesting = false
      })
    },
    setAccompanyImpact(accompany, impact) {
      if (this.requesting) {
        return
      }

      this.requesting = true

      axios.post(
        this.route('indicators.impact'),
        {
          _token: this.$page.props.auth.user.csrf_token,
          id: Number(accompany._id),
          impact: impact,
        },
      ).then(() => {
        this.requesting = false

        accompany.impact = impact

        setTimeout(() => this.invertDisplay(accompany._id), 1e2)
      }).catch(() => {
        this.requesting = false
      })
    },
    endAccompany(accompany) {
      if (this.requesting) {
        return
      }

      this.requesting = true

      axios.post(
        this.route('indicators.end'),
        {
          _token: this.$page.props.auth.user.csrf_token,
          id: Number(accompany._id),
          commentary: accompany.commentary,
        },
      ).then(() => {
        this.requesting = false

        if (accompany.commentary === null) {
          accompany.commentary = '...'
        }
      }).catch(() => {
        this.requesting = false
      })
    },
    selectAccompany(id) {
      if (this.requesting) {
        return
      }

      if (this.accompanieds[id]) {
        this.selectedAccompanies = true

        return
      }

      for (const index in this.accompanieds) {
        if (this.accompanieds[index]) {
          return
        }
      }

      this.selectedAccompanies = false
    },
    close() {
      if (this.requesting) {
        return
      }

      this.$emit('close')
    },
    exportPDF() {
      if (this.requesting) {
        return
      }

      this.$refs.pdf.generatePdf()
    },
    showFirstTypeAction() {
      document.querySelector('ul.tabs-nav').children.item(0).click()
    },
    assembleModels(insightsParam = null) {
      this.accompanieds = {}

      const insights = insightsParam ?? this.insights

      insights.forEach((insight) => {
        if (insight.accompanies) {
          insight.accompanies.forEach((accompany) => {
            this.accompanieds[accompany._id] = accompany.selected
          })
        }
      })
    },
    invertDisplay(id) {
      const down = document.getElementById(`${id}-chevron-down`)
      const up = document.getElementById(`${id}-chevron-up`)
      const accompany = document.getElementById(`${id}-accompany`)

      if (accompany.classList.contains('hidden')) {
        accompany.classList.remove('hidden')

        up.classList.remove('hidden')
        down.classList.add('hidden')

        return
      }

      accompany.classList.add('hidden')

      up.classList.add('hidden')
      down.classList.remove('hidden')
    },
    getByType(type) {
      const insights = []

      this.insights.forEach((insight) => {
        if (insight.type === type) {
          insights.push(insight)
        }
      })

      return insights
    },
    getAccompaniesByType(type) {
      const accompanies = []

      this.getByType(type).forEach((action) => {
        if (action.accompanies && action.accompanies.length > 0) {
          action.accompanies.forEach((accompany) => {
            if (accompany.selected) {
              accompanies.push(accompany)
            }
          })
        }
      })

      return accompanies
    },
    hasAccompanies(tab) {
      for (const insight of tab) {
        if (insight.accompanies) {
          return true
        }
      }
    },
  },
}
</script>
